import React, { FC, useCallback, useState } from 'react';
import PageContainer from '../page-container/page-container';
import { Heading } from '../utils/heading';
import { useDispatch, useSelector } from 'react-redux';
import { WebAppState } from '../../../state/store.web';
import { localized } from '../../../../shared/state/i18n/i18n';
import { ViewWeb } from '../utils/web-view';
import './user-profile-form.scss'; // Reusing the same styles
import { SkioldButton } from '../skiold-components/skiold-button/skiold-button';
import { SkioldFormsWrapper } from '../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { FormRow } from '../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';
import { SkioldFormInput } from '../skiold-components/skiold-input/skiold-form-input';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { SkioldCheckbox } from '../skiold-components/skiold-checkbox/skiold-checkbox';
import { InviteProfile } from 'shared/state/ducks/profile/operations';
import { IUserProfile, UserProfile } from 'shared/api/api';
// Import your invitation/create operation here
// import { CreateUserInvitation } from '../../../../shared/state/ducks/authorizations/operations';

interface PropsFromParent {
	closeModal: () => void;
}

export const UserProfileForm: FC<PropsFromParent> = React.memo(({ closeModal }) => {
	const dispatch = useDispatch();
	// Get all available sites to show as options
	const allSites = useSelector((state: WebAppState) => state.userSites.userSites);

	// Form States
	const [email, setEmail] = useState('');
	const [name, setName] = useState('');
	const [initials, setInitials] = useState('');
	const activeSiteId = useSelector((state: WebAppState) => state.site.site.id);

	const onInitialsChange = useCallback((text: string) => {
		if (text.length > 3) return;
		setInitials(text.toUpperCase());
	}, []);

	const handleSave = useCallback(() => {
		const userData: IUserProfile = {
			email,
			name,
			initials,
			isDeleted: false,
			admin: false,
			active: false,
			siteId: activeSiteId,
		};

		InviteProfile(userData)(dispatch);

		closeModal();
	}, [email, name, initials, activeSiteId, dispatch, closeModal]);

	const formRows: FormRow[] = [
		{
			name: localized('Name'),
			component: <SkioldFormInput text={name} onChangeText={setName} />,
		},
		{
			name: localized('Email'),
			component: <SkioldFormInput text={email} onChangeText={setEmail} />,
		},
		{
			name: localized('Initials'),
			component: <SkioldFormInput text={initials} onChangeText={onInitialsChange} />,
		},
	];

	return (
		<PageContainer>
			<Heading allLettersCapitalized={false} text={localized('Invite New User')} />
			<ViewWeb className={'edit-user-container'}>
				<SkioldFormsWrapper formRows={formRows} />

				<ViewWeb className={'button-view-style'}>
					<SkioldButton title={localized('Cancel')} onPress={closeModal} theme={'grey'} />
					<SkioldButton
						title={localized('Send Invitation')}
						onPress={handleSave}
						disabled={!email || !name} // Basic validation
					/>
				</ViewWeb>
			</ViewWeb>
		</PageContainer>
	);
});
